var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNachrichtVersendet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Nachricht_versendet",
    "data-name": "Nachricht versendet",
    xmlns: "http://www.w3.org/2000/svg",
    width: 279.818,
    height: 187.766,
    viewBox: "0 0 279.818 187.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nachricht_versendet-2",
    "data-name": "Nachricht versendet",
    transform: "translate(31.387 0) rotate(14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_569",
    "data-name": "Pfad 569",
    d: "M13.274,0,147.337,11.942l102.14,14.6L103.534,55.067,0,57.721Z",
    transform: "translate(-0.006 73.694) rotate(-14)",
    fill: "rgba(94,203,162,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_568",
    "data-name": "Pfad 568",
    d: "M0,38.528l21.019,31.43L72.613,1.2,65.859,0,21.019,59.86,5.263,35.559Z",
    transform: "translate(13.162 17.56) rotate(-14)",
    fill: "#d9e4e8",
    stroke: "#004969",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_563",
    "data-name": "Pfad 563",
    d: "M0,35.468,34,20.3,142.432-.011,21.63,33.39Z",
    transform: "translate(58.695 2.965)",
    fill: "#edfbfc",
    stroke: "#004969",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_564",
    "data-name": "Pfad 564",
    d: "M0,14.52,103.976,1.8,24.489,0,10.9,3.793Z",
    transform: "translate(97.115 1.591)",
    fill: "#edfbfc",
    stroke: "#004969",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_565",
    "data-name": "Pfad 565",
    d: "M0,19.772l30.07-5.717L104.612-.008.616,13.068Z",
    transform: "translate(96.515 2.772)",
    fill: "#d9e4e8",
    stroke: "#004969",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_566",
    "data-name": "Pfad 566",
    d: "M26.3,52.749,120.415,4.194l-.187-4.2L0,33.507Z",
    transform: "translate(80.847 3.022)",
    fill: "#d9e4e8",
    stroke: "#004969",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_567",
    "data-name": "Pfad 567",
    d: "M0,15.943,18.627,33.121,56.968,0Z",
    transform: "translate(131.879 6.392)",
    fill: "#eaeaea",
    stroke: "#004969",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_570",
    "data-name": "Pfad 570",
    d: "M33.8,1.5c-53.112-10.543-36.25,37.861,0,39.951s33.847-5.714,33.847-5.714",
    transform: "translate(30.205 37.547) rotate(-14)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    strokeDasharray: "1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_572",
    "data-name": "Pfad 572",
    d: "M70.759,0c16.81,14.444,7.086,39.756-28.134,41.976S0,53.078,0,53.078",
    transform: "translate(9.119 54.142) rotate(-14)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    strokeDasharray: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNachrichtVersendet);
export default __webpack_public_path__ + "static/media/Nachricht_versendet.97efc107abc6f1fb9caaad9b08e192a4.svg";
export { ForwardRef as ReactComponent };